<template>
	<IconButtonLayout
		class="calendar-clock-button"
		type="QUATERNARY"
	>
		<FontAwesomeIcon :icon="[ `far`, `calendar-clock` ]" />
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "CalendarClockButton",
	components: {
		IconButtonLayout,
	},
};
</script>
